import { QueryClient } from "@tanstack/react-query";
// if you have a shared client:
import { Request } from "../apis/requests";

export const handleLogout = async (queryClient?: QueryClient) => {
  try {
    // clear refresh cookie on the server
    await Request.post("/auth/logout", {}, { withCredentials: true });
  } catch (_) {
    // ignore; still clear client state
  } finally {
    // 1) remove token + session
    localStorage.removeItem("access_token");
    sessionStorage.removeItem("created-doctor");

    // 2) remove default Authorization header to avoid sending stale token
    if (Request?.defaults?.headers?.common) {
      delete Request.defaults.headers.common["Authorization"];
    }

    // 3) clear react-query cache if you use it
    queryClient?.clear?.();

    // 4) hard redirect (ensures all memory is reset)
    window.location.replace("/login");
  }
};

// export const handleLogout = () => {
//   localStorage.clear();
//   sessionStorage.removeItem("created-doctor"); // ✅ important
//   window.location.href = "/login";
// };
